export const initialStepData = {
  uploadResponse: [],
  id: "",
  name: "",
  email: "",
  phone: "",
  website: "",
  pages: [],
  selectedPages: [],
  designRevamp: "",
  frontend: "",
  backend: "",
  grandTotal: "",
  AIResponse: [],
  frontendTotal: "",
  backendTotal: "",
  designRevampTotal: "",
  totalDays: "",
  originalFiles: [],
  urls: [],
  supportOptions: "",
  backButton: false,
  modrewrite: "",
};
